import { RoundAvatar } from "@kamae-apps/shared/Components/Atoms/RoundAvatar/RoundAvatar"
import { DropdownMenu, type DropdownMenuEntries } from "@kamae-apps/shared/Components/Molecules/Dropdown/Menu/Menu"
import useClickOutside from "@kamae-apps/shared/Hooks/useClickOutside"
import type TUser from "@kamae-apps/shared/Types/TUser"
import clsx from "clsx"
import { FC, useRef, useState } from "react"
import { SidebarMode, useSidebarMode } from "../../../Contexts/SidebarMode/SidebarModeContext"

type UserMenuProps = {
  user: TUser
  entries: DropdownMenuEntries[]
  getRoundedAvatarUrl: (avatar?: string) => string
}

export const UserMenu: FC<UserMenuProps> = props => {
  const userMenuRef = useRef<HTMLDivElement>(null)
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const { mode } = useSidebarMode()
  useClickOutside(userMenuRef, () => setIsMenuOpen(false))

  return (
    <div
      ref={userMenuRef}
      className={"relative"}
    >
      <button
        className={clsx(
          "flex h-13 items-center gap-3 rounded-xl py-3 px-2.5",
          mode === SidebarMode.MOBILE && "w-13",
          mode === SidebarMode.COLLAPSED && "w-12",
          mode === SidebarMode.EXPANDED && "w-full px-5",
          isMenuOpen
            ? clsx("bg-neutral-gray-50 bg-opacity-100", mode !== SidebarMode.MOBILE && "bg-white")
            : "bg-white bg-opacity-30 hover:bg-opacity-50"
        )}
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        type={"button"}
      >
        <RoundAvatar
          imgSrc={props.getRoundedAvatarUrl(props.user.avatar)}
          imgAlt={`${props.user.avatar}_rounded`}
          size={"s"}
        />
        {mode === SidebarMode.EXPANDED && <p className={"caption-regular"}>{props.user.first_name}</p>}
      </button>
      {isMenuOpen && (
        <div
          className={clsx(
            "absolute",
            mode === SidebarMode.MOBILE && "right-0 bottom-14",
            mode === SidebarMode.COLLAPSED && "bottom-0 left-13",
            mode === SidebarMode.EXPANDED && "bottom-0 left-51"
          )}
        >
          <DropdownMenu
            entries={props.entries}
            onCloseMenu={() => setIsMenuOpen(false)}
          />
        </div>
      )}
    </div>
  )
}
